import { isPublicHost, publicLocation, referrerHost, reportablePath } from "./analyticsPrivacy";
export const ANALYTICS_ID = "G-B5CXTPFE76";
export const AD_CLIENT = "ca-pub-4419428690072900";
export { isPublicHost };

const appendScript = (id, src) => {
  if (document.getElementById(id)) return;
  const script = document.createElement("script");
  Object.assign(script, { id, src, async: true, crossOrigin: "anonymous" });
  document.head.appendChild(script);
};

/** Preview and automated checks must never request real advertising inventory. */
export const loadAds = () => {
  if (typeof window === "undefined" || !isPublicHost(window.location.hostname)) return false;
  appendScript("studentcalc-ads", `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${AD_CLIENT}`);
  return true;
};

/** Reuses the existing property; route views are sent explicitly without user queries. */
export const loadAnalytics = () => {
  if (typeof window === "undefined" || !isPublicHost(window.location.hostname)) return false;
  if (window.__studentcalcAnalyticsReady) return true;
  window.__studentcalcAnalyticsReady = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  const path = reportablePath(window.location.pathname);
  window.gtag("config", ANALYTICS_ID, { send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false, page_location: publicLocation(window.location.hostname, path), page_referrer: referrerHost(document.referrer) });
  appendScript("studentcalc-analytics", `https://www.googletagmanager.com/gtag/js?id=${ANALYTICS_ID}`);
  return true;
};
